import React, {Component, createRef} from 'react';
import { Link } from 'react-router-dom';
import * as Scroll from 'react-scroll';

export default class ProgramCourses extends Component {

	constructor(props) {
		super(props);

		this.state = {
			openCollapse: null,
		}
		this.summaryContainer = createRef();
		this.renderTerms = this.renderTerms.bind(this);
		this.renderCourse = this.renderCourse.bind(this);
		this.renderCourseTitleList = this.renderCourseTitleList.bind(this);
		this.renderMobileTerm = this.renderMobileTerm.bind(this);
		this.renderCourseCardForMobile = this.renderCourseCardForMobile.bind(this);
	}

	renderCourse(courses) {
		if (!courses) {
			return;
		}
		return courses.map((course, index) => {
			if (!course) {
				return null;
			}
			return (
				<div key={index}>
					<h5>{course.title}</h5>
					<p>{course.summary}</p>
					<span className="link">مشاهده توضیحات کامل</span>
				</div>
			);
		});
	}

	renderCourseTitleList(courses) {
		if (!courses) {
			return;
		}

		let items = courses.map((course, index) => {
			return <li key={index}>{ course && course.title }</li>
		});

		return <ul>{items}</ul>
	}

	renderTerms(terms) {
		if (!terms) {
			return;
		}
		return terms.map((item, index) => {
			let list = this.renderCourseTitleList(item.courses);
			let headerCardClassName = "title";
			let summaryContainerStyle = {
				width: '100%',
				overflow: 'hidden',
				maxHeight: '0',
				border: '0',
				transition: 'all 0.8s ease-out',
				transitionProperty: 'max-height, border',
			};
			let headerTitle = "شرح دروس";
			let headerTitleClassName = "link";
			let arrowImageSrc = "/images/arrow-left.svg";
			if (index === this.state.openCollapse) {
				arrowImageSrc = "/images/arrow-down-dark.svg";
				headerTitleClassName = "link toggle";
				headerCardClassName = "title remove-radius";
				summaryContainerStyle = {
					width: '100%',
					overflow: 'hidden',
					transition: 'max-height 0.8s ease-out',
					maxHeight: document.getElementById(`acc-index-${index}`) && document.getElementById(`acc-index-${index}`).scrollHeight
				};
				headerTitle = 'نمای خلاصه';
				list = (
					<ul>
						<li></li>
						<li></li>
					</ul>
				);
			}
			return (
				<div key={index} className="term__info">
					<div className={headerCardClassName} onClick={() => {
						if (this.state.openCollapse !== index) {
							this.setState({openCollapse: index});
						} else {
							this.setState({openCollapse: null});
						}
					}}>
						<img src={arrowImageSrc} alt="" />
						<span>{item.title}</span>
						{list}
						<div className={headerTitleClassName}>{ headerTitle }</div>
					</div>
					<div>
						<div id={`acc-index-${index}`} className="summary" style={summaryContainerStyle}>
							{this.renderCourse(item.courses)}
						</div>
					</div>
				</div>
			)
		});
	}

	renderCourseCardForMobile(courses) {
		return courses.map((course) => {
			return (
				<Link key={course.id} to={`/course/${course.id}`}>
					<div className="card">
						<div className="top" style={{
							background: `url(${course.image})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: '100% auto',
							backgroundPositionY: 'center',
							// height: '20px'
						}}></div>
						<h5 className="name">{course.title}</h5>
					</div>
				</Link>
			)
		})
	}

	renderMobileTerm() {
		return this.props.items.map((term, index) => {
			return (
				<div className="term" key={`term:${index}`}>
					<div className="right">
						<span className="shape">
							<span className="name">{term.title}</span>
						</span>
					</div>
					<div className="cards">
						{this.renderCourseCardForMobile(term.courses)}
					</div>
				</div>
			)
		})
	}

	render() {
		return (
			<Scroll.Element name="mba-courses" className="program dr-margin">
				<h3>برنامه درسی</h3>
				<div className="web">
					<div className="terms">
						{/* {this.renderTerms(items)} */}
						<p className="dsc">
						دوره آنلاین MBA دانشگاه صنعتی شریف، یک‌ساله و مشتمل بر 11 درس اصلی است که در قالب ۶ ترم دوماهه ارائه می‌شوند. دانشجویان در هر بازه‌ی دو ماهه، دو درس را به صورت همزمان می‌گذرانند.
						</p>
						<Link to="/courses" className="chart">
							<img src="/images/dore-yek-sale.png" alt="دوره یکساله MBA" />
						</Link>
					</div>
					<div className="board">
						<h5 className="title">در یک نگاه</h5>
						<div className="for-md-res">
							<ul className="items">
								<li>
									<i className="icon icon-dr-time"></i>
									<span>طول دوره: ۱ سال</span>
								</li>
								<li>
									<i className="icon icon-dr-term"></i>
									<span>6 ترم</span>
								</li>
								<li>
									<i className="icon icon-dr-comment small"></i>
									<span>بحث و یادگیری جمعی</span>
								</li>
								<li>
									<i className="icon icon-dr-paper small"></i>
									<span>تمرین و ارزیابی </span>
								</li>
							</ul>
						</div>
						{/* <div className="lastdate">آخرین مهلت ثبت نام  ۱۵ اردیبهشت</div> */}
						{/* eslint-disable-next-line */}
						<a onClick={(e) => {e.preventDefault(); this.props.onBuyProgram()}} className="btn btn--lg btn--primary">ثبت‌نام</a>
					</div>
				</div>
				<div className="mobile">
					<p className="text">دوره آنلاین MBA آکادمی درایـت یک‌ساله و مشتـــــمل بـر 11 درس اصلـی اسـت که در قالـب ۶ ترم دوماهـه ارائه می‌شوند. دانشجویـان در هـر بازه‌ی دو ماهـه، دو درس را به صورت همزمان می‌گذرانند.</p>
					{this.renderMobileTerm()}
					{/* <div className="term">
						<div className="right">
							<span className="shape">
								<span className="name">ترم 1</span>
							</span>
						</div>
						<div className="cards">
							<div className="card">
								<img src="/images/program.png" className="top" alt="term"/>
								<h5 className="name">حسابداری برای مدیران</h5>
							</div>
							<div className="card">
								<img src="/images/program.png" className="top" alt="term"/>
								<h5 className="name">حسابداری برای مدیران</h5>
							</div>
						</div>
					</div>
					<div className="term">
						<div className="right">
							<span className="shape">
								<span className="name">ترم 1</span>
							</span>
						</div>
						<div className="cards">
							<div className="card">
								<img src="/images/program.png" className="top" alt="term"/>
								<h5 className="name">حسابداری برای مدیران</h5>
							</div>
							<div className="card">
								<img src="/images/program.png" className="top" alt="term"/>
								<h5 className="name">حسابداری برای مدیران</h5>
							</div>
						</div>
					</div> */}
				</div>
			</Scroll.Element>
		);
	}
}